export default "__VITE_ASSET__Cpv1ieur__"